<template>
  <div class="container">

    <div class="top-row">
      <h3>Share via WhatsApp Push</h3>
      <div class="button-container">

        <!-- Add More Numbers Button -->
        <a-button @click="showAddMoreRespondents" class="add-respondents-btn btn">Add More Numbers</a-button>

        <!-- Send All Button -->
        <a-button
        v-if="!is_sending_queued_pushes"
        @click="sendAll"
        class="send-all-btn btn"
        :class="{ disabled: paid_push_credits_remaining < queued_count || queued_count === 0 }"
        :disabled="paid_push_credits_remaining < queued_count">Send All ({{ queued_count }})</a-button>

        <!-- Spinner while Sending All Pushes -->
        <a-spin v-else class="spinner">
          <a-icon slot="indicator" type="loading" style="font-size: 25px; color: #1BD285; width: 128px; margin-top: 7px" spin />
        </a-spin>


        <!-- Dot Dot Dot Menu -->
        <a-dropdown :trigger="['click']" >
          <a-menu slot="overlay">
            <a-menu-item @click="unqueueAllPushes">Clear Queued</a-menu-item>
            <a-menu-item @click="exportCSV">Export as CSV</a-menu-item>
          </a-menu>
          <button class="dotdotdot-btn"></button>
        </a-dropdown>

      </div>
    </div>

    <div class="table-pagination-and-search">
      <p>{{ (page - 1) * 20 }}-{{ page * 20 < whatsapp_pushes.length ? page * 20 : whatsapp_pushes.length }} of {{ whatsapp_pushes.length }} Respondents</p>
      <a-pagination v-model="page" :total="whatsapp_pushes.length" :defaultPageSize="20" :hideOnSinglePage="true" />
    </div>

    <div class="table-headers">
      <div class="phone-header"    @click="sort('phone')" :class="{ filter_desc: this.sorting === 'phone_desc', filter_asc: this.sorting === 'phone_asc' }">
        <p>Phone #</p>
      </div>
      <div class="uid-header"     @click="sort('uid')" :class="{ filter_desc: this.sorting === 'uid_desc', filter_asc: this.sorting === 'uid_asc' }">
        <p>UID</p>
      </div>
      <div class="progress-header" @click="sort('progress')" :class="{ filter_desc: this.sorting === 'progress_desc', filter_asc: this.sorting === 'progress_asc' }">
        <p>Survey Progress</p>
      </div>
      <div class="event-header"    @click="sort('time')" :class="{ filter_desc: this.sorting === 'time_desc', filter_asc: this.sorting === 'time_asc' }">
        <p>Last Event</p>
      </div>
      <div class="status-header">
        <a-select @change="selectStatus($event)" :value="selected_status" default-value="All Statuses">
          <a-select-option v-for="status of ['All Statuses', 'Queued', 'Sent', 'No WhatsApp', 'Delivered', 'Read', 'Opted Out', 'Survey Started', 'Survey Completed']" :value="status" :key="status">{{ status }}</a-select-option>
        </a-select>
      </div>
    </div>

    <div class="table">

      <div v-for="push of filtered_whatsapp_pushes" class="table-row">
        <div class="phone-cell">
          <p><span class="flag"></span>&nbsp;&nbsp;+{{ push.phone }}</p>
        </div>
        <div class="name-cell">
          <p @click="goToRespondentPage(push.respondent_id)">{{ push.respondent_id }}</p>
        </div>
        <div class="progress-cell">
          <div class="progress-outer">
            <div class="progress-inner" v-if="push.progress_step || push.status === 'survey_completed'" v-bind:style="{ width: (push.status !== 'survey_completed' ? (push.progress_step / study_step_count * 85) : 85) + 'px' }"></div>
          </div>
          <p>{{ push.progress_step ? `${Math.floor(push.progress_step / study_step_count * 100)}%` : (push.status === 'survey_completed' ? '100%' : '-') }}</p>
        </div>
        <div class="event-cell">
          <p>{{ formatTime(push.time) }}</p>
        </div>

        <div v-if="push.status === 'queued'" class="send-cell">

          <!-- Individual Send Push Button -->
          <button
          @click="sendPush(push.id)"
          :disabled="paid_push_credits_remaining < 1"
          :class="{ disabled: paid_push_credits_remaining < 1 }">Send</button>

          <!-- Individual Delete (Unqueue) Push Button -->
          <div @click="unqueuePush(push.id)" class="unqueue-push"></div>

        </div>
        <div v-if="push.status === 'sending'" class="sending-cell">
          <a-spin class="spinner">
            <a-icon slot="indicator" type="loading" style="font-size: 16px; color: #1BD285; width: 20px; margin-top: 0px" spin />
          </a-spin>
          <p>Sending</p>
        </div>
        <div v-if="push.status !== 'queued' && push.status !== 'sending'" class="status-cell">
          <div class="status-circle" :class="push.status"></div>
          <p>{{ formatStatus(push.status) }}</p>
        </div>
      </div>

    </div>


    <a-modal v-model="this.is_sending_queued_pushes === true" centered :closable="false" :maskClosable="false" :footer="null">
      <template>
        <div class="send-all-progress-modal">
          <p>Sent {{ sent_count }} of {{ sending_count }} pushes</p>
          <a-progress :percent="Math.round(sent_count / sending_count * 100)" />
        </div>
      </template>
    </a-modal>

  </div>
</template>

<script>

import moment from 'moment';
const { parse } = require('json2csv');

export default {
  name: 'WhatsappList',
  props: {
    whatsapp_pushes: Array,
  },
  data() {
    return {
      sorting: 'none',
      selected_status: 'All Statuses',
      sending_count: 0,
      sent_count: 0,
      page: 1,
    }
  },
  computed: {

    filtered_whatsapp_pushes() {

      let filtered_pushes = this.whatsapp_pushes;

      if (!filtered_pushes) { // Empty results
        return filtered_pushes;
      };

      // Sort results
      if (this.sorting !== 'none') {
        let column = this.sorting.split('_')[0];
        let sorting = this.sorting.split('_')[1];
        filtered_pushes = _.orderBy(filtered_pushes, [column], [sorting]);
      };

      // Select statuses
      if (this.selected_status !== 'All Statuses') {
        let status_map = {
          'Queued' : 'queued',
          'Sent' : 'sent',
          'No WhatsApp' : 'failed',
          'Delivered' : 'delivered',
          'Read' : 'read',
          'Opted Out' : 'survey_opted_out',
          'Survey Started' : 'survey_started',
          'Survey Completed' : 'survey_completed',
        };
        filtered_pushes = _.filter(filtered_pushes, ['status', status_map[this.selected_status]]);
      };

      // Paginate the results
      const page_size = 20;
      filtered_pushes = filtered_pushes.slice(((this.page - 1) * page_size), (this.page * page_size));

      return filtered_pushes;

    },


    study_step_count() {
      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;
      let survey = surveys[survey_index];
      if (survey && survey.questions) {
        return _.keys(survey.questions).length;
      } else {
        return 1;
      };
    },

    is_sending_queued_pushes() {
      return this.$store.state.loading_data['is_sending_queued_pushes'];
    },

    queued_count() {
      return _.filter(this.whatsapp_pushes, ['status', 'queued']).length;
    },

    survey() {
      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;
      return surveys ? surveys[survey_index] : null;
    },

    paid_push_credits_remaining() {
      if (this.$store.state.billing) {
        return Math.floor(this.$store.state.billing.wallet_balance / 0.1);
      } else {
        return 0;
      };
    }

  },

  methods: {

    showAddMoreRespondents() {
      this.$emit('showAddMoreRespondents');
    },

    sendPush(push_id) {
      let survey_index = this.$route.params.survey_index;
      this.$store.dispatch('sendWhatsappPush', { survey_index, push_id });
      let account_id = this.$store.state.user.account_id;
      analytics.track('Distribute Send Push', { survey_id: this.survey.id, account_id });
    },

    unqueuePush(push_id) {
      let survey_index = this.$route.params.survey_index;
      this.$store.dispatch('unqueueWhatsappPushes', { survey_index, push_ids: [push_id] });
      this.$message.success(`Successfully removed push`, 2);
    },

    unqueueAllPushes() {
      let survey_index = this.$route.params.survey_index;
      let queued_pushes = _.filter(this.whatsapp_pushes, ['status', 'queued']);
      let push_ids = _.map(queued_pushes, 'id');
      this.$store.dispatch('unqueueWhatsappPushes', { survey_index, push_ids });
      this.$message.success(`Successfully cleared all queued pushes`, 2);
    },


    async sendAll() {

      // Show loading message at the top
      this.$message.loading(`Sending WhatsApp Pushes..`, 3);

      let survey_index = this.$route.params.survey_index;
      let queued_pushes = _.filter(this.whatsapp_pushes, ['status', 'queued']);
      let push_ids = _.map(queued_pushes, 'id');
      for (let push_id of push_ids.slice(0, 20)) {
        this.$store.commit('setWhatsappPushStatusSending', { survey_index, push_id });
      };

      //console.log('push_ids.length', push_ids.length);

      let account_id = this.$store.state.user.account_id;
      let client_id = this.$store.state.user.uid;
      let survey_id = this.survey.id;
      analytics.track('Distribute Send All Pushes', { survey_id, account_id, count: push_ids.length });

      this.sending_count = push_ids.length;

      // Show progress modal
      this.$store.commit('setLoading', { loading_key: 'is_sending_queued_pushes', loading_value: true });

      // Chunk push ids (only for displaying how many are left in progress modal)
      const BATCH_SIZE = 50;
      let chunks = _.chunk(push_ids, BATCH_SIZE);
      let that = this;

      for (let chunk of chunks) {
        await sendBatchOfPushes(chunk.length);
        this.sent_count += chunk.length;
      };

      // Reset data
      setTimeout(() => {
        that.$store.commit('setLoading', { loading_key: 'is_sending_queued_pushes', loading_value: false });
        that.$store.dispatch('setWhatsappPushes', { survey_index, get_live_data: true });
       }, 500);

       setTimeout(() => {
         that.sending_count = 0;
         that.sent_count = 0;
       }, 1000);


      function sendBatchOfPushes(push_count) {

        return new Promise((resolve, reject) => {

          // Update wallet balance
          that.$store.commit('decrementWalletBalanceForPush', push_count);

          // Call API to send all queued pushes for the given survey
          that.$axios.post(`https://api-outsidevoice.vercel.app/send-queued-whatsapp-pushes`, {
            survey_id,
            client_id
          }).then(res => {
            resolve();
          }).catch(err => {
            console.log(err);
            resolve();
          });

        });
      };

    },

    sort(column) {
      if (this.sorting === 'none' || !this.sorting.includes(column)) {
        this.sorting =  `${column}_desc`;
      } else if (this.sorting.includes('desc')) {
        this.sorting =  `${column}_asc`;
      } else {
        this.sorting = 'none';
      };
    },

    selectStatus(status) {
      this.selected_status = status;
    },

    formatTime(unix) {
      return moment.unix(unix).format("h:mma MMM D");
    },

    formatStatus(status) {

      if (status === 'queued') {
        return 'Queued';
      } else if (status === 'sent') {
        return 'Delivered';
      } else if (status === 'failed') {
        return 'No Whatsapp';
      } else if (status === 'delivered') {
        return 'Delivered';
      } else if (status === 'read') {
        return 'Read';
      } else if (status === 'survey_opted_out') {
        return 'Opted Out';
      } else if (status === 'survey_started') {
        return 'Started';
      } else if (status === 'survey_completed') {
        return 'Completed';
      } else {
        return 'Queued';
      };

    },

    goToRespondentPage(uid) {
      this.$router.push({ name: 'respondent', params: { uid } });
    },

    exportCSV: async function() {
      const fields = ['phone_number', 'uid', 'time_sent', 'time_survey_started'];
      let formatted_pushes = _.map(this.whatsapp_pushes, push => {
        return ({
          phone_number: push.phone,
          uid: push.respondent_id,
          time_sent: push.time_sent ? moment.unix(push.time_sent).format("h:mma MMM D") : '',
          time_survey_started: push.time_survey_started ? moment.unix(push.time_survey_started).format("h:mma MMM D") : 'Not started'
        });
      });
      console.log(formatted_pushes);
      const opts = { fields };
      const csv = parse(formatted_pushes, opts);
      var dataStr = "data:text/csv;charset=UTF-8," + encodeURIComponent(csv);
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "survey_pushes.csv");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },

  }
}
</script>

<style scoped lang="scss">

.container{
  width: 80%;
  background-color: white;
  border: 1px solid rgb(216,216,216);
  border-radius: 6px;
}

.top-row{

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 25px;
  padding-left: 30px;
  padding-right: 10px;

  h3{
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    margin-top: 8px;
    padding-right: 35px;
    background-size: 25px;
    background-position: right;
    background-repeat: no-repeat;
    background-image: url("../../assets/whatsapp-logo.svg");
  }

  .button-container{

    display: flex;
    align-items: flex-start;
    padding-left: 45px;
    padding-right: 10px;

    .btn{
      font-size: 14px;
      font-weight: 600;
      color: rgb(30,30,30);
      height: 39px;
      background-color: rgb(255,255,255);
      padding: 0px 13px 1px 13px;
      margin-left: 18px;
      opacity: .85;
      border-radius: 6px;
      border: 1px solid rgb(210,210,210);
      box-shadow: 0 0 3px 0 rgba(0,0,0,.05);
      transition: all 0.3s ease;
      cursor: pointer;
      &:hover{
        opacity: 1;
        background-color: rgb(250,250,250);
      }
    }

    .send-all-btn{
      color: white;
      background: #2c3052; /* Old browsers */
      opacity: .95;
      background: -moz-linear-gradient(top, #2c3052 0%, #1e2032 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, #2c3052 0%,#1e2032 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, #2c3052 0%,#1e2032 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      border-color: black;
      cursor: pointer;
      &.disabled{
        background: rgb(200,200,200);
        border-color: rgb(140,140,140);
        cursor: not-allowed;
      }
    }

    .dotdotdot-btn{
      height: 42px;
      width: 42px;
      background-image: url("../../assets/icons/dotdotdot-btn.svg");
      background-repeat: no-repeat;
      background-position: 7.5px 8px;
      background-size: 26px 26px;
      margin-left: 15px;
      opacity: .7;
      border: none;
      transition: all 0.3s ease;
      //transform: translate(15px, 10px);
      border-radius: 6px;
      background-color: rgb(250,250,250);
      cursor: pointer;
      &:hover{
        opacity: 1;
        background-color: rgb(245,245,245);
      }
      &:focus{
        outline: none;
      }
    }
  }
}

.table-pagination-and-search{
  padding: 10px 35px;
  padding-top: 25px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  p{
    font-size: 14px;
    font-weight: 500;
    color: rgb(40,40,40);
  }
}

.table-headers{
  background-color: rgb(247,247,247);
  margin-top: 30px;
  padding-left: 10px;
  border-bottom: 1px solid rgb(230,230,230);
  border-top: 1px solid rgb(230,230,230);
  div{
    width: 20%;
    padding: 16px 0px;
    padding-left: 20px;
    display: inline-block;
    margin: 0px;
    border-right: 1px solid rgb(230,230,230);
    background-size: 21px;
    background-position: right;
    background-repeat: no-repeat;
    background-image: url("../../assets/icons/table-ordering-arrow-none.svg");
    &.filter_asc{
      background-image: url("../../assets/icons/table-ordering-arrow-asc.svg");
    }
    &.filter_desc{
      background-image: url("../../assets/icons/table-ordering-arrow-desc.svg");
    }

    &.phone-header{
      width: 160px;
    }
    &.uid-header{
      width: 140px;
    }
    &.progress-header{
      width: 170px;
    }
    &.event-header{
      width: 140px;
    }
    &.status-header{
      width: 150px;
      background-image: none;
      padding-left: 8px;
      div{
        width: 100%;
        padding: 0px;
        padding-right: 15px;
      }
    }
    &:first-child{
      border-left: none;
    }
    &:last-child{
      border-right: none;
    }
    p{
      font-size: 13px;
      font-weight: 600;
      color: rgb(20,20,20);
      margin: 0px;
      user-select: none;
    }
  }
}

.table{
  padding-bottom: 50px;
  .table-row{
    padding-left: 10px;
    border-bottom: 1px solid rgb(235,235,235);
    & > div{
      display: inline-block;
      padding: 16px 0px;
      padding-left: 20px;
      border-right: 1px solid rgb(245,245,245);
      &.phone-cell{
        width: 160px;
        letter-spacing: -.75px;
        .flag{
          font-size: 16px;
        }
      }
      &.name-cell{
        width: 140px;
        p{
          &:hover{
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
      &.progress-cell{
        width: 170px;
        & > *{
          display: inline-block;
        }
        .progress-outer{
          position: relative;
          width: 85px;
          height: 6px;
          background-color: rgb(240,240,240);
          margin-right: 13px;
          border-radius: 4px;
          transform: translateY(-1px);
          .progress-inner{
            width: 20px;
            height: 6px;
            background-color: #24DBA4;
            border-radius: 4px;
            position: absolute;
              top: 0;
              left: 0;

          }
        }
      }
      &.event-cell{
        width: 140px;
      }
      &.status-cell{
        width: 150px;
        padding-left: 15px;
        & > *{
          display: inline-block;
        }
        .status-circle{
          height: 8px;
          width: 8px;
          margin-right: 10px;
          margin-left: 2px;
          border-radius: 4px;
          background-color: rgb(225,225,225);
          &.sent{
            background-color: #24DBA4;
          }
          &.read{
            background-color: #A029DB;
          }
          &.failed{
            background-color: rgb(225,225,225);
          }
          &.survey_opted_out{
            background-color: #FFB476;
          }
          &.survey_started{
            background-color: #24B3DB;
          }
          &.survey_completed{
            background-color: #2958DB;
          }
          &.dropped{
            background-color: rgb(225,225,225);
          }
        }
      }
      &.send-cell{
        & > *{
          display: inline-block;
          vertical-align: middle;
        }
        button{
          font-size: 13px;
          font-weight: 600;
          color: rgb(30,30,30);
          background-color: white;
          background-size: 11px;
          background-position: 56px 9px;
          background-repeat: no-repeat;
          background-image: url("../../assets/icons/table-send-arrow.svg");
          padding: 4px 15px;
          padding-right: 33px;
          margin-left: -2px;
          border: 1px solid rgb(235,235,235);
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s ease;
          &:hover{
            border: 1px solid rgb(200,200,200);
          }
          &:focus{
            outline: none;
          }
          &.disabled{
            opacity: .6;
            cursor: not-allowed;
          }
        }
        .unqueue-push{
          height: 25px;
          width: 25px;
          margin-left: 10px;
          background-size: 11px;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url("../../assets/icons/close-btn.svg");
          border-radius: 20px;
          cursor: pointer;
          transition: all 0.15s ease;
          &:hover{
            background-color: rgb(240,240,240);
          }
        }
      }
      &.sending-cell{
        & > *{
          display: inline-block;
          vertical-align: middle;
        }
        p{
          margin-left: 10px;
        }
      }
      &:first-child{
        border-left: none;
      }
      &:last-child{
        border-right: none;
      }
      p{
        font-size: 13px;
        font-weight: 600;
        margin: 0;
      }
    }
  }
}

.send-all-progress-modal{
  padding: 10px 25px 15px 25px;
  p{
    text-align: center;
    font-size: 15px;
  }
}

</style>
